import classes from './Footer.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../../Button/Button';
import Text from '../../../typography/Text/Text';

function Footer(props) {
  let {
    children,
    cancelButtonText,
    onOK,
    onCancel,
    okButtonText,
    okDisabled,
    cancelDisabled,
    className,
    okButtonClassName,
    cancelButtonClassName,
    hintText,
    okButtonProps
  } = props;

  let content = children ? (
    children
  ) : (
    <div className={classnames(classes.buttons, className)}>
      {onOK && (
        <Button
          type="submit"
          primary
          small
          className={classnames(classes.buttonsCell, okButtonClassName)}
          disabled={okDisabled}
          onClick={onOK}
          {...okButtonProps}
        >
          {okButtonText}
        </Button>
      )}
      {onCancel && (
        <Button
          primary
          invert
          small
          className={classnames(classes.buttonsCell, cancelButtonClassName)}
          disabled={cancelDisabled}
          onClick={onCancel}
        >
          {cancelButtonText}
        </Button>
      )}
    </div>
  );

  return (
    <div className={classnames(classes.base, className)}>
      {hintText && <Text>{hintText}</Text>}
      {content}
    </div>
  );
}

Footer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  okButtonClassName: PropTypes.string,
  cancelButtonClassName: PropTypes.string,
  okButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  onOK: PropTypes.func,
  onCancel: PropTypes.func,
  okDisabled: PropTypes.bool,
  cancelDisabled: PropTypes.bool,
  okButtonProps: PropTypes.object,
  hintText: PropTypes.string
};

Footer.defaultProps = {
  okButtonProps: {}
};

export default Footer;
